import React from 'react'
import Colors from '../colors'
import Button from '../components/Button'
import { useNavigate } from 'react-router-dom';

const containerStyles = {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '30px',
    alignItems: 'center'
}

const styles404 = {
    fontSize: 'max(12vw, 100px)',
    fontWeight: 'bold',
    color: Colors.green
}

const container404styles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 'max(2vw, 10px)',
    marginRight: '7px'
}

const logoStyles = {
    width: 'max(10vw, 90px)',
    height: 'max(10vw, 90px)',
    marginLeft: '15px',
    marginBottom: '10px'
}

const headingContainerStyles = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    maxWidth: '90%',
    marginTop: '15px',
    marginBottom: '25px'
}


const headingStyles = {
    fontSize: '40px',
    fontWeight: 'bold',
    color: Colors.mediumGray,
}

const subheadingStyles = {
    fontSize: '20px',
    marginBottom: '20px'
}

function NotFound() {
    const navigate = useNavigate();
    return (
        <div style={containerStyles}>
            <div style={container404styles}>
                <span style={styles404}>4</span>
                <img src="/logo.png" alt="logo" style={logoStyles} />
                <span style={styles404}>4</span>
            </div>
            <div style={headingContainerStyles}>
                <span style={headingStyles}>Wrong Turn?</span>
                <span style={subheadingStyles}>We can't find the page you're looking for...</span>
            </div>
            <Button onClick={() => navigate('/')} color={Colors.green}>Return to Dashboard</Button>
        </div>
    )
}

export default NotFound